export default "__VITE_ASSET__CK0Ho0Pj__"